import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';

const mutationMfaDeactivationConfirmation = (onSuccess, onError) => {
    return {
        mutationFn: ({ resourceActionTokenUuid }) => {
            return client.post(SESSION.MFA_DEACTIVATION_CONFIRMATION.url, { resourceActionTokenUuid });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationMfaDeactivationConfirmation;